import JSEncrypt from "jsencrypt";

const normalizePublicKey = (rawKey) => {
  if (!rawKey) return null;

  let normalizedKey = rawKey.trim();
  normalizedKey = normalizedKey.replace(/\\n/g, "\n");

  if (!normalizedKey.includes("BEGIN PUBLIC KEY")) {
    normalizedKey = `-----BEGIN PUBLIC KEY-----\n${normalizedKey}\n-----END PUBLIC KEY-----`;
  }

  return normalizedKey;
};

export const encryptPassword = (password = "") => {
  if (!password) return "";

  const publicKey = normalizePublicKey(process.env.REACT_APP_PUBLIC_KEY);

  if (!publicKey) {
    console.error("🔐 REACT_APP_PUBLIC_KEY is missing. Please add it to your .env file.");
    throw new Error("Encryption public key is not configured");
  }

  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);

  const encrypted = encrypt.encrypt(password);
  if (!encrypted) {
    throw new Error("Password encryption failed. Please verify the public key format.");
  }

  return encrypted;
};
